import { GetFieldDefBy } from "./GetFieldDefBy";

export function GetTopSubChart(dataObj) {
  var fieldDef = dataObj.GetFieldDefByID("TopOfSubChart");
  var isTop = dataObj.GetFieldValue(fieldDef);
  return isTop;
}
